import {
  FetchFormRequest,
  UpdateField,
  UpdateFormRequest,
} from './../forms.actions'
import { getUpdateFormState } from './../forms.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnDestroy, OnInit } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subscription } from 'rxjs'
import { Map, List } from 'immutable'
import { SetDefaultData } from '../forms.actions'
import {
  FetchFormPostprocessorRequest,
  FetchFormPostprocessorsRequest,
} from '@containers/form-postprocessors/form-postprocessors.actions'
import { getFormPostprocessorState } from '@containers/form-postprocessors/form-postprocessors.selectors'

@Component({
  selector: 'app-update-form',
  templateUrl: './update-form.component.html',
  styleUrls: ['./update-form.component.css'],
})
export class UpdateFormComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private postprocessors$: Subscription
  public isLoading: boolean
  public formId: number
  public postprocessors: any[] = []

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.formId = parseInt(this.route.snapshot.paramMap.get('id'))
    this.store.dispatch<any>(new SetDefaultData('updateForm'))
    this.store.dispatch<any>(new FetchFormPostprocessorsRequest())
    this.state$ = this.store
      .pipe(select(getUpdateFormState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.postprocessors$ = this.store
      .pipe(select(getFormPostprocessorState))
      .subscribe((state) => {
        this.postprocessors = state.get('data')?.toJS()
      })

    this.store.dispatch<any>(new FetchFormRequest(this.formId))
  }

  ngOnDestroy(): void {
    this.state$.unsubscribe()
    this.postprocessors$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'updateForm.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'updateForm',
      ),
    )
  }

  onFormChange(rows: List<Map<string, any>>) {
    this.handleFieldChange(rows, 'form')
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event, redirect = true): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateFormRequest(this.formId, payload, redirect))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateForm',
        ),
      )
    }
  }
}
